import React, { useContext, useEffect, useState } from "react";
import ScreenOne from "./ScreenOne";
import DisplayTotal from "./DisplayTotal";
import ScreenTwo from "./ScreenTwo";
import ScreenThree from "./ScreenThree";
import GuidanceAndSupport from "./GuidanceAndSupport";
import { Button } from "@mui/material";
import ScreenZero from "./ScreenZero";
import { RegisterFormContext } from "../../Context/RegisterFormContext";
import ChooseClasses from "./ChooseClasses";
import ChooseTutor from "./ChooseTutor";
import ScreenFour from "./ScreenFour";
import StudentInfo from "./StudentInfo";
import GuardianInfo from "./GuardianInfo";
import BillingInfo from "./BillingInfo";
import { MyContext } from "../../Context/MyContext";

export default function NewRegisterForm() {
  const {
    formData,
    zero,
    one,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
    nine,
    ten,
    availableScreens,
    costs,
    setFormData,
  } = useContext(RegisterFormContext);

  
    const { currency, convertPrice } =
      useContext(MyContext);

  useEffect(() => {
    setFormData((prev) => {
      let newTotalCost = 0;
  
      if (
        prev.tutoringSupport &&
        prev.program &&
        prev.package === "Lesson Plan Package" &&
        prev.selectedSubjects
      ) {
        newTotalCost =
          costs[prev.tutoringSupport][prev.program][prev.hours] *
          prev.selectedSubjects.length;
      } else if (
        prev.tutoringSupport &&
        prev.program &&
        prev.package === "Pay As you learn" &&
        prev.selectedSubjects
      ) {
        newTotalCost =
          costs[prev.tutoringSupport][prev.program]["hourly"] *
          prev.selectedSubjects.length *
          prev.hours;
      }
  
      if (
        prev.tutoringSupport &&
        prev.program === "IB DP" &&
        prev.guidanceAndSupport?.needed &&
        prev.guidanceAndSupport?.hours > 0
      ) {
        newTotalCost += prev.guidanceAndSupport.hours * costs["Guidance And Support"];
      }
  
      return {
        ...prev,
        totalCost: convertPrice(newTotalCost, currency),
        totalCostAfterGuidanceAndSupport: convertPrice(newTotalCost, currency),
      };
    });
  }, [
    formData.tutoringSupport,
    formData.program,
    formData.package,
    formData.selectedSubjects,
    formData.hours,
    formData.guidanceAndSupport?.needed,
    formData.guidanceAndSupport?.hours,
    costs,
  ]);
  
  

  return (
    <div
      style={{
        margin: "1rem auto",
        width: "100%",
        background: "#fff",
        borderRadius: "1rem",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "auto",
        }}
      >
        <div>
          <h1 style={{ padding: "1rem", width: "100%", textAlign: "center" }}>
            Register Student Form
          </h1>
          <DisplayTotal />
          <div ref={zero}>
            <ScreenZero />
          </div>
          {availableScreens.screen1 && (
            <div ref={one}>
              <ChooseClasses />
            </div>
          )}

          {availableScreens.screen2 && (
            <div ref={two}>
              <ScreenOne />
            </div>
          )}

          {availableScreens.screen3 && (
            <div ref={three}>
              <ChooseTutor />
            </div>
          )}

          {availableScreens.screen4 > 0 && (
            <div ref={four}>
              <ScreenTwo />
            </div>
          )}

          {availableScreens.screen5 && (
            <div ref={five}>
              <ScreenThree />
            </div>
          )}

          {availableScreens.screen6 && (
            <div ref={six}>
              <ScreenFour />
            </div>
          )}

          {availableScreens.screen7 && formData.program === "IB DP" && (
            <div ref={seven}>
              <GuidanceAndSupport />
            </div>
          )}

          {availableScreens.screen8 && (
            <div ref={eight}>
              <StudentInfo />
            </div>
          )}

          {availableScreens.screen9 && (
            <div ref={nine}>
              <GuardianInfo />
            </div>
          )}

          {availableScreens.screen10 && (
            <div ref={ten}>
              <BillingInfo />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
